import React from 'react';
import {connect} from 'react-redux';
import UberEatsDisplayedGames from './Widgets/Games';

const UberEatsGame = props => (
  <div id="ue-game">
    <header className="content-header">
      <h1>
        Game
        <small> GOAT Uber Eats</small>
      </h1>
    </header>
    <section className="content">
      <div className="row">
        <div className="col-md-12">
          <UberEatsDisplayedGames />
        </div>
      </div>
    </section>{' '}
  </div>
);

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(UberEatsGame);



// WEBPACK FOOTER //
// ./src/pages/UberEats/Game/index.tsx